import {Component, inject, Inject, OnDestroy, OnInit, Renderer2} from '@angular/core';
import {RouterOutlet} from "@angular/router";
import {DOCUMENT} from "@angular/common";
import {AccessService} from "./services/access.service";
import {Subscription} from "rxjs";

@Component({
    selector: 'app-root',
    imports: [RouterOutlet],
    template: `
        <router-outlet/>
    `,
})
export class AppComponent implements OnInit, OnDestroy {

    private accessService = inject(AccessService);
    private renderer = inject(Renderer2);
    private document = inject(DOCUMENT);

    clientLoadedSubscription = new Subscription();

    ngOnInit(): void {
        this.clientLoadedSubscription = this.accessService.clientLoaded.subscribe(loaded => this.setFavicons());
    }

    ngOnDestroy(): void {
        this.clientLoadedSubscription.unsubscribe();
    }

    private setFavicons(): void {
        const basePath = `assets/img/favicon/` + this.accessService.client!.slug;

        this.updateLink('apple-touch-icon', `${basePath}/apple-touch-icon.png`, 'link[rel="apple-touch-icon"]', '180x180');
        this.updateLink('icon', `${basePath}/favicon-32x32.png`, 'link[rel="icon"][sizes="32x32"]', '32x32');
        this.updateLink('icon', `${basePath}/favicon-16x16.png`, 'link[rel="icon"][sizes="16x16"]', '16x16');
        this.updateLink('manifest', "manifest-" + this.accessService.client!.slug + ".json", 'link[rel="manifest"]');
    }

    private updateLink(rel: string, href: string, selector: string, sizes?: string): void {
        let link = this.document.querySelector(selector) as HTMLLinkElement;

        if (!link) {
            link = this.renderer.createElement('link');
            this.renderer.setAttribute(link, 'rel', rel);
            if (sizes) {
                this.renderer.setAttribute(link, 'sizes', sizes);
                this.renderer.setAttribute(link, 'type', 'image/png');
            }
            this.renderer.appendChild(this.document.head, link);
        }

        this.renderer.setAttribute(link, 'href', href);

        document.documentElement.style.setProperty('--primary', this.accessService.client.primaryColor);
    }
}
